// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2024 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.deliveries.home],
        guard: getPermissionsGuard([{ resource: 'portal.delivery', scopes: ['view'] }]),
        controller: () => import('./controllers/deliveries')
    },
    {
        path: [config.routes.deliveries.import],
        guard: getPermissionsGuard([{ resource: 'portal.delivery', scopes: ['create', 'edit'] }]),
        controller: () => import('./controllers/importDelivery')
    },
    {
        path: [config.routes.deliveries.launch],
        controller: () => import('./controllers/launchDelivery')
    }
];
